module.exports = __webpack_public_path__ + "img/app-store-badge.e422d824.png";